import {
  mfgModalShellClass,
  mfgPrimaryBtnLgClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  open: boolean;
  acknowledging: boolean;
  onAcknowledge: () => void;
};

/** MSDS-4 Path B — first open of an AI-generated draft. */
export function ManufacturingMaterialSdsAckModal({
  open,
  acknowledging,
  onAcknowledge,
}: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className={`w-full max-w-md p-5 ${mfgModalShellClass}`}>
        <h4 className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
          AI-generated SDS — verify before use
        </h4>
        <p className="mt-2 text-xs text-gray-600 dark:text-zinc-300">
          This sheet was drafted with AI assistance. Review every section before workplace use.
          Prefer a manufacturer or distributor SDS when one is available. Turbo Assist does not
          provide EHS or legal compliance certification.
        </p>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            className={mfgPrimaryBtnLgClass}
            onClick={onAcknowledge}
            disabled={acknowledging}
          >
            {acknowledging ? "Saving…" : "I understand — continue"}
          </button>
        </div>
      </div>
    </div>
  );
}
